import { makeStyles } from '@material-ui/core';
import { MDSPopup, MDSPopupActions, MDSPopupContent } from '@marqvision/mds/core/Popup';
import { MDSButton, MDSTheme } from '@marqvision/mds/core';
import { IcoErrorWarningFill } from '@marqvision/mds/assets';
import { MDSTypography } from '@marqvision/mds-v2';

const useStyles = makeStyles({
  content: {
    display: 'grid',
    gridTemplateColumns: 'auto 1fr',
    gap: '12px',
  },
  icon: {
    width: '24px',
    height: '24px',
    '& path': {
      fill: MDSTheme.palette.bluegray[900],
    },
  },
});

type Props = {
  isOpen: boolean;
  onLeave: () => void;
  onStay: () => void;
};

export const CancelDialog = (props: Props) => {
  const { isOpen, onLeave, onStay } = props;
  const classes = useStyles();

  return (
    <MDSPopup onClose={onStay} width="400px" style={{ display: isOpen ? 'block' : 'none' }}>
      <MDSPopupContent>
        <div className={classes.content}>
          <IcoErrorWarningFill className={classes.icon} />
          <MDSTypography weight="medium">
            Are you sure you want to leave? <br />
            Changes may not be saved. <br />
          </MDSTypography>
        </div>
      </MDSPopupContent>
      <MDSPopupActions>
        <MDSButton variant="outline" color="red" size="medium" onClick={onLeave}>
          Leave
        </MDSButton>
        <MDSButton variant="outline" color="bluegray" size="medium" onClick={onStay}>
          Stay
        </MDSButton>
      </MDSPopupActions>
    </MDSPopup>
  );
};
